const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const JsonBuilderQuery: any = {
    GetJsonTemplatesData: Backofficebff + '/v1/json/templates',
    GetJsonTemplateById: Backofficebff + '/v1/json/templates',
};
